module.exports = __webpack_public_path__ + "static/media/phone-com-tag.d734ae2c.svg";